import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form,Upload,Icon,message} from 'antd';

import { Select, Input ,Button} from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet,asyncGetQ } from './reducers';
import { formItemLayout, formatFormData } from './utils';
import Urls from "../../../../config";
const FormItem = Form.Item;
const { TextArea } = Input;
const { certificateUrl } = Urls;
class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
        this.props.updateFileList([]);
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.item.certificateId === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
                this.props.updateFileList([]);
            } else {
                console.log(err);
            }
        });
    };


    handleUploadImg =data=> {
        console.log(data);
        this.props.updateFileList([{file: data.file }]);
        this.props.form.setFieldsValue({ file: data.file });
    };

    render() {
        const propsImg = {
            showUploadList: false,
            name: 'file',
            action: 'upload',
            customRequest: this.handleUploadImg,
        };

        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本ID">
                            {getFieldDecorator('certificateId', {
                                initialValue: item.certificateId || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入ID ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="密码">
                            {getFieldDecorator('pwd', {
                                initialValue: item.pwd || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入密码 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}  />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem label="证书文件" {...formItemLayout}>
                            {getFieldDecorator('file', {
                                rules: [
                                    {
                                        required: false,
                                        message: '请上传证书',
                                    },
                                ],
                            })(
                                <div>
                                    <Upload {...propsImg}  fileList={ this.props.fileList} style={{marginLeft: '20px'}}>
                                        <Button type="default" >
                                            <Icon type="upload" /> 上传
                                        </Button>
                                    </Upload>
                                </div>
                            )}
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={true}
                    footer={[
                        // 定义右下角 按钮的地方 可根据需要使用 一个或者 2个按钮
                        <Button key="back"  onClick={this.handleOk}>确定</Button>,
                    ]}
                >
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.certificateList.list.reduce((a, b) => (b.certificateId === state.certificateList.currentSelectId ? b : a), {}),
    isModalShow: state.certificateList.uiStatus.isUpdateShow,
    isLoading: state.certificateList.uiStatus.isLoading,
    fileList: state.certificateList.fileList,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    asyncGetQ: () => dispatch(asyncGetQ()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
    updateFileList: (params)=> dispatch(actions.updateFileList(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/client/certificateList/edit.js